// If you don't want to use TypeScript you can delete this file!
import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import PromoProvider from 'src/context/PromoContext'
import { RenderModules } from 'src/utils/renderModules'
import { FloatingToc, TocItem } from 'src/components/global/floatingToc'

const queryClient = new QueryClient()

const getHeadingLabel = (text: any[] = []) => {
  const heading = text.find(
    (block: any) =>
      block?._type === 'block' &&
      (block.style === 'h2' || block.style === 'h3')
  )

  const children = Array.isArray(heading?.children) ? heading.children : []

  return children
    .filter((child: any) => child._type === 'span')
    .map((child: any) => child.text)
    .join('')
    .trim()
}

const getModuleHeadingLabel = (module: any): string | undefined => {
  if (module?._type === 'careTeam' && typeof module.title === 'string') {
    const careTeamTitle = module.title.trim()
    if (careTeamTitle) return careTeamTitle
  }

  const label = getHeadingLabel(module.text)
  if (label) return label

  for (const item of module.items || []) {
    const nestedLabel = getModuleHeadingLabel(item)
    if (nestedLabel) return nestedLabel
  }

  return undefined
}

const extractTocItems = (modules: any[]): TocItem[] => {
  if (!modules) return []
  return modules
    .filter((m: any) => m.options?.uid)
    .map((m: any) => {
      const label = getModuleHeadingLabel(m)
      return {
        id: m.options.uid,
        label: label || m.options.uid,
      }
    })
}

export const Content = ({
  modules,
  showToc,
}: {
  modules: any[]
  showToc?: boolean
}) => {
  const tocItems = showToc ? extractTocItems(modules) : []

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <PromoProvider>
          {RenderModules(modules, { priorityFirstModuleImage: true })}
          {showToc && tocItems.length > 0 && <FloatingToc items={tocItems} />}
        </PromoProvider>
      </QueryClientProvider>
    </>
  )
}

export default Content
